"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Hooks = __importStar(require("@apollo/react-hooks"));
var react_1 = __importDefault(require("react"));
var ApolloDefender_1 = require("../ApolloDefender");
var useLoadingStash_1 = require("./useLoadingStash");
function useLazyQuery(query, options) {
    var _a = __read(Hooks.useLazyQuery(query, __assign({ fetchPolicy: 'cache-and-network' }, options)), 2), execute = _a[0], result = _a[1];
    ApolloDefender_1.useApolloDefenderReporter(result.error, query, result.variables);
    var resolveRef = react_1.default.useRef();
    // ! Small hack as the official useLazyQuery's execution function does not return
    // ! promise with result which is useful in some case. Could be dropped eventually.
    react_1.default.useEffect(function () {
        if (result.called && !result.loading && resolveRef.current) {
            resolveRef.current(result.data || null);
            resolveRef.current = undefined;
        }
    }, [result.data, result.loading, result.called]);
    var queryLazily = react_1.default.useCallback(function (variables, context) {
        execute({ variables: variables, context: context });
        return new Promise(function (resolve) {
            resolveRef.current = resolve;
        });
    }, [execute]);
    var getStash = useLoadingStash_1.useLoadingStash(result.loading, result.data);
    var wrappedResult = __assign(__assign({}, result), { getStash: getStash,
        get hasData() {
            return this.data !== undefined;
        },
        get hasError() {
            return this.error !== undefined;
        } });
    return [queryLazily, wrappedResult];
}
exports.useLazyQuery = useLazyQuery;
//# sourceMappingURL=useLazyQuery.js.map